import React from "react"

import BaseNav from "./base-nav"
import MainNav from "./main-nav"

import "./style.less"

const Nav = ({ location, routeParams }) => (
  <div className="navbar-container flex flex-wrap flex-col h-full font-montserrat-13 font-semibold">
    <BaseNav location={location} routeParams={routeParams} />
    <MainNav routeParams={routeParams} />
  </div>
)

export default Nav
